export * from './seo';

export const DOMAIN_NAME = 'baomoi.com';
export const DOMAIN_URL = 'https://baomoi.com';
export const DOMAIN_MOBILE_URL = 'https://m.baomoi.com';
export const LOG_URL = 'https://log.baomoi.com';
export const FB_FANPAGE = 'https://www.facebook.com/Baomoi';
export const DOMAIN_ADS = 'https://web.api.adtimaserver.vn';
export const PHOTO_URL: string =
    process.env.PHOTO_URL || 'https://photo-baomoi.bmcdn.me/';
export const ASSET_PATH = process.env.APP_ASSET_PATH || '';
export const PREFIX = 'bm';
export const TOTAL_PAGINATION = 1000;

export const GA4_TRACKING_ID = 'G-1Q3Y03E60F';
export const ZALO_APP_ID = '4373017067085156544';

export const SECTION_ID = {
    FORM: 'form',
    NEXT_MATCH: 'nextMatch',
    STANDING: 'standing',
    TOURNAMENT: 'tournament',
    CONTENT_TOP: 'content_top',
    MATCHES_TOP: 'matches_top',
    TOURNAMENTS_TOP: 'tournaments_top',
    CONTENT_LOAD_MORE: 'content_load_more'
}

export const URL_SOCCER_PAGE = {
    LIVESCORE: '/bong-da/livescore.epi',
    LIVE: '/bong-da/truc-tiep.epi',
    HOME: '/bong-da.epi',
    ALL_LEAGUES: '/bong-da/tat-ca-giai-dau.epi',
    SUBPATH: '/bong-da/'
};

export enum CONTENT_TYPE {
    TEXT = 'text',
    IMAGE = 'image',
    PHOTO = 'photo',
    AUDIO = 'audio',
    VIDEO = 'video',
    AD_NATIVE = 'adNative',
    AD_BANNER = 'adBanner',
}

export enum PAGE_TYPE {
    CONTENT_DETAIL = 'contentdetail',
}

export enum DEVICES {
    DESKTOP = 'desktop',
    TABLET = 'tablet',
    MOBILE = 'mobile',
}

export enum OS {
    ANDROID = 'android',
    IOS = 'ios',
}

export enum PLATFORM {
    WEB = 1,
    WAP = 2,
    APP = 4,
    ZNEWS = 8,
}

export enum CONTENT_TYPE_VALUE {
    PHOTO = 1,
    VIDEO = 2,
    LIVE = 4096,
}

export enum OBJECT_TYPE {
    PUBLISHER = '3',
    CLUSTER = '5',
    TOPIC = '7',
}

export enum CONTENT_SUB_TYPE {
    IMAGE_CAPTION = 'media-caption',
    AUTHOR = 'body-author',
    BODY_BLOCK = 'body-block',
    LIVE_BODY_BLOCK = 'live-body-block',
    TIME_STRING = 'time-string',
    TIME_CAPTION = 'time-caption',
}

export enum VIEW_TYPE {
    GRID = 'grid',
}

export enum ERROR_CODE {
    NOT_FOUND_ID = -108,
    REQUIRE_LOGIN = -801,
    CLIENT = -99998,
    UNKNOWN = -99999,
}

export enum SUPPORT_VIDEO {
    PROBABLY = 'probably',
    MAYBE = 'maybe',
    CANNOT = '',
}

export enum SPEECH_MODE {
    AUTO = 'auto',
    MANUAL = 'manual',
}

export const MODAL_ID = 'react-cool-portal';
export const MODAL_CLASS = 'soccer-portal-modal';
export const TIMER_GET_LIVE = 15000;

export const EVENT = {
    PLAYER_PLAY: 'PLAYER_PLAY',
    SCRIPT_AD_LOAD_SUCCESS: 'SCRIPT_AD_LOAD_SUCCESS',
};

export const PLACE_HOLDER = {
    IMAGE: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
    VIDEO: 'https://baomoi-static.bmcdn.me/web/styles/img/player-default-03.png',
};

export * from './storage';

export const EXCLUDE_ERROR_CODES = [-801];

export const I_MINI_SIZE = 744;

export type SIZE = 'small' | 'medium' | 'large';
export type STATE = 'hover' | 'focus' | 'active' | 'loading';
export type IMAGE_SIZE =
    | '120x120'
    | '190x190'
    | '210x118'
    | '290x290'
    | '170x170'
    | '';
export type BREAKPOINTS = {
    FULLHD: 'fullhd';
    WIDESCREEN: 'widescreen';
    DESKTOP: 'desktop';
    TOUCH: 'touch';
    TABLET: 'tablet';
    MOBILE: 'mobile';
};
export type POSITION = 'left' | 'right' | 'center';
export type COLUMN_TYPE = 'main' | 'sub' | 'full';
export type ALIGN_TYPE = 'vertical' | 'horizontal';


// match
export enum MATCH_STATUS {
    NOT_STARTED = 0,
    LIVE = 1,
    HT = 2,
    FT = 3,
    ET = 4,
    PS = 5,
    POSTPONED = 6
}

export const MATCH_TYPE = {
    NOT_STARTED: 'Not started',
    LIVE: 'Live',
    HT: 'Half Time',
    FT: 'Full Time',
    ET: 'Extra Time',
    PS: 'Penalty shootout',
    POSTPONED: 'postponed'
};